/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect, useState} from 'react'
import SMSCARD from './SMSCARD'
import LeadServiceAPI from '../../../api/LeadServiceAPI'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import GridCard from './GridCard'
import {CKEditor} from '@ckeditor/ckeditor5-react'
import {EditorConfig} from '@ckeditor/ckeditor5-core'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import {toast} from 'react-toastify'
import authAPI from '../../../api/authAPI'
import moment from 'moment'
import EMAILCARD from './EMAILCARD'
import NOTECARD from './NOTECARD'
import OTHERCARD from './OTHERCARD'

function ContactUserDetails() {
  const [activeState, setActiveState] = useState(1)
  const [leadDetails, setLeadDetails] = useState<any>({})
  const [selectedImage, setSelectedImage] = useState<any>(null)
  const [noteModalOpen, setNoteModalOpen] = useState(false)
  const [emailModalOpen, setEmailModalOpen] = useState(false)
  const [smsModalOpen, setSmsModalOpen] = useState(false)
  const [emailModalMinimize, setEmailModalMinimize] = useState(false)
  const [smsModalMinimize, setSmsModalMinimize] = useState(false)
  const [activityList, setActivityList] = useState<any>([])
  const [notesList, setNotesList] = useState<any>([])
  const [emailList, setEmailList] = useState<any>([])
  const [smsList, setSMSList] = useState<any>([])
  const role = JSON.parse((localStorage.getItem('kt-auth-react-v') as any) || {})?.data?.role
    ?.role_id
  const [userId, setUserId] = useState(null)
  const [selectedEdit, setSelectedEdit] = useState<number>(0)
  const handleChangeState = (state: number) => {
    setActiveState(state)
  }
  const currentUrl = window.location.href
  const getIdFromUrl = (url: string) => {
    // Create a new URL object
    const urlObj = new URL(url)

    // Get the pathname from the URL
    const pathname = urlObj.pathname

    // Use regular expressions to extract the ID from the pathname
    const regex = /\/(\d+)\/?$/
    const match = regex.exec(pathname)

    // Return the extracted ID or null if no match was found
    return match ? match[1] : null
  }
  const leadID = getIdFromUrl(currentUrl)

  //   get lead details
  const getLeadDetails = () => {
    LeadServiceAPI.getLeadDetails(leadID).then((res: any) => {
      if (res?.data?.success) {
        setLeadDetails(res?.data?.data)
        setSelectedImage(res?.data?.leadImageFolderPath + '/' + res?.data?.data?.image)
      }
    })
  }
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = toAbsoluteUrl('/media/icons/profile.png')
  }
  useEffect(() => {
    getLeadDetails()
  }, [])

  useEffect(() => {
    authAPI.getMyProfile().then((res: any) => {
      if (res?.data?.success) {
        setUserId(res?.data?.user_id)
      } else {
        setUserId(null)
      }
    })
  }, [])
  // Note form
  const openModal = () => {
    setNoteModalOpen(true)
    getActivityList()
  }

  const closeModal = () => {
    setNoteModalOpen(false)
    setTitle('')
    setEditorData('')
    setSelectedEdit(0)
  }
  // Email form
  const openEmailModal = () => {
    setEmailModalOpen(!emailModalOpen)
    setEmailModalMinimize(false)
  }
  const openSMSModal = () => {
    setSmsModalOpen(!smsModalOpen)
    setEmailModalMinimize(false)
  }

  const closeEmailModal = () => {
    setEmailModalOpen(false)
  }
  const closeSmsModal = () => {
    setSmsModalOpen(false)
  }

  const minimizeEmailModal = () => {
    setEmailModalOpen(false)
    setEmailModalMinimize(true)
  }
  const minimizeSmsModal = () => {
    setSmsModalOpen(false)
    setSmsModalMinimize(true)
  }

  const [title, setTitle] = useState('')
  const [subject, setSubject] = useState('')
  const [smsDescription, setSmsDescription] = useState('')
  const [editorData, setEditorData] = useState('')
  const [emailEditorData, setEmailEditorData] = useState('')

  const handleTitleChange = (e: any) => {
    setTitle(e.target.value)
  }
  const handleSubjectChange = (e: any) => {
    setSubject(e.target.value)
  }

  const handleEditorDataChange = (event: any, editor: any) => {
    const data = editor.getData()
    setEditorData(data)
  }
  const handleEmailEditorDataChange = (event: any, editor: any) => {
    const data = editor.getData()
    setEmailEditorData(data)
  }
  // clear note fields
  const clearNoteFields = () => {
    setTitle('')
    setEditorData('')
    setSelectedEdit(0)
  }

  // clear note fields
  const clearEmailFields = () => {
    setSubject('')
    setEmailEditorData('')
  }
  const handleSubmit = (e: any) => {
    e.preventDefault()
    // API call
    let data = {}
    if (selectedEdit === 0) {
      data = {
        type: '1',
        lead_id: leadID,
        subject: title,
        details: editorData,
      }
    } else {
      data = {
        id: selectedEdit,
        // type: '1',
        // lead_id: leadID,
        subject: title,
        details: editorData,
      }
    }
    if (selectedEdit > 0) {
      LeadServiceAPI.editNote(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})
            setNoteModalOpen(false)
            clearNoteFields()
            getNotes()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    } else {
      LeadServiceAPI.createNote(data).then(
        (res: any) => {
          if (res?.data?.success) {
            toast.success(res?.data?.message, {theme: 'dark'})
            setNoteModalOpen(false)
            clearNoteFields()
            getNotes()
          } else {
            toast.error(res?.data?.message, {theme: 'dark'})
          }
        },
        (err: any) => {
          toast.error(err?.response?.data?.message, {theme: 'dark'})
        }
      )
    }
  }
  const handleEmailSubmit = (e: any) => {
    e.preventDefault()

    // API call
    let data = {}
    data = {
      lead_id: leadID,
      subject: subject,
      details: emailEditorData,
    }
    LeadServiceAPI.sendEmail(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          setEmailModalOpen(false)
          clearEmailFields()
          getActivityList()
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  const handleSmsSubmit = (e: any) => {
    e.preventDefault()

    // API call
    let data = {}
    data = {
      lead_id: leadID,
      details: smsDescription,
    }
    LeadServiceAPI.sendSMS(data).then(
      (res: any) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message, {theme: 'dark'})
          setSmsModalOpen(false)
          setSmsDescription('')
          getActivityList()
        } else {
          toast.error(res?.data?.message, {theme: 'dark'})
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  const editorConfig = {
    toolbar: {
      items: ['bold', 'italic', '|', 'undo', 'redo'],
    },
    placeholder: 'Add Notes',
  }
  const editorEmailConfig: EditorConfig = {
    toolbar: {
      items: ['bold', 'italic', 'underline', '|', 'undo', 'redo', '|', 'link'],
    },
    placeholder: 'Add Email Body',
  }

  const handleEditNote = (data: any) => {
    setSelectedEdit(data?.id)
    setNoteModalOpen(true)
    setActiveState(2)
    setEditorData(data?.details)
    setTitle(data?.subject)
  }
  // Note Form END

  // get Activity List
  const getActivityList = () => {
    let data = {
      lead_id: Number(leadID),
      limit: 100,
      offset: 0,
    }
    LeadServiceAPI.getAllActivityList(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setActivityList(res?.data?.data)
          // console.log(activityList, 'activityList')
        } else {
          setActivityList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  // get notes
  const getNotes = () => {
    let data = {
      lead_id: Number(leadID),
      type: 1,
      limit: 100,
      offset: 0,
    }
    LeadServiceAPI.getNotesList(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setNotesList(res?.data?.data)
        } else {
          setNotesList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  // get Emails
  const getEmailList = () => {
    let data = {
      lead_id: Number(leadID),
      type: 2,
      limit: 100,
      offset: 0,
    }
    LeadServiceAPI.getEmailList(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setEmailList(res?.data?.data)
          // console.log(res?.data?.data, 'email list')
        } else {
          setEmailList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }
  // get Emails
  const getSMSList = () => {
    let data = {
      lead_id: Number(leadID),
      type: 3,
      limit: 100,
      offset: 0,
    }
    LeadServiceAPI.getSMSList(data).then(
      (res: any) => {
        if (res?.data?.success) {
          setSMSList(res?.data?.data)
          // console.log(res?.data?.data, 'sms list')
        } else {
          setSMSList([])
        }
      },
      (err: any) => {
        toast.error(err?.response?.data?.message, {theme: 'dark'})
      }
    )
  }

  // init
  useEffect(() => {
    getActivityList()
    getNotes()
    getEmailList()
    getSMSList()
  }, [])
  // render
  return (
    // <div className='container'>
    <div>
      <button
        className='bg-transparent border-0'
        onClick={() => {
          window.history.back()
        }}
      >
        <i
          className='fa fa-angle-left py-2 px-3'
          aria-hidden='true'
          style={{background: '#fff', borderRadius: '50%'}}
        ></i>{' '}
        <span className='fw-bold fs-5 px-2'>Back</span>
      </button>
      <div className='col-lg-12 row'>
        <div className='col-lg-4'>
          <div style={{marginTop: 66}} />
          <div className='card px-5'>
            <div className='d-flex justify-content-center text-center' style={{marginTop: -50}}>
              <img
                src={selectedImage}
                alt='profile'
                height={85}
                onError={handleImageError}
                style={{
                  borderRadius: '50%',
                  width: '100px',
                  height: '100px',
                  backgroundColor: 'white!important',
                  border: '3px solid white',
                }}
              />
            </div>
            <h5 className='my-5 text-center text-capitalize fw-bolder'>
              {leadDetails?.lead_type === 1
                ? leadDetails?.name
                : leadDetails?.company_name || 'Name missing'}
            </h5>

            <div className='container d-flex flex-row flex-wrap justify-content-around mb-3'>
              <div className='icon-container'>
                <button
                  onClick={openModal}
                  type='button'
                  className='btn btn-sm btn-light py-3 px-3'
                  style={{borderRadius: '50%'}}
                >
                  <span className='svg-icon svg-icon-primary svg-icon-2x m-0'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24px'
                      height='24px'
                      viewBox='0 0 24 24'
                      version='1.1'
                    >
                      <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                        <rect x='0' y='0' width='24' height='24' />
                        <path
                          opacity='0.3'
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M14.4862 18L12.7975 21.0566C12.5304 21.54 11.922 21.7153 11.4386 21.4483C11.2977 21.3704 11.1777 21.2597 11.0887 21.1255L9.01653 18H5C3.34315 18 2 16.6569 2 15V6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V15C22 16.6569 20.6569 18 19 18H14.4862Z'
                          fill='black'
                        />
                        <path
                          fill-rule='evenodd'
                          clip-rule='evenodd'
                          d='M6 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H6C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7ZM6 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11Z'
                          fill='black'
                        />
                      </g>
                    </svg>
                  </span>
                </button>
                <div className='icon-title'>Notes</div>
              </div>

              <div className='icon-container'>
                <button
                  onClick={openEmailModal}
                  type='button'
                  className='btn btn-sm btn-light py-3 px-3'
                  style={{borderRadius: '50%'}}
                >
                  <span className='svg-icon svg-icon-primary svg-icon-2x m-0'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24px'
                      height='24px'
                      viewBox='0 0 24 24'
                      version='1.1'
                    >
                      <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                        <rect x='0' y='0' width='24' height='24' />
                        <path
                          d='M5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z'
                          fill='#000000'
                        />
                      </g>
                    </svg>
                  </span>
                </button>
                <div className='icon-title'>Emails</div>
              </div>

              <div className='icon-container text-center'>
                <button
                  type='button'
                  className='btn btn-sm btn-light py-3 px-3'
                  style={{borderRadius: '50%', height: 45, width: 45}}
                >
                  <span className='svg-icon svg-icon-primary svg-icon-2x m-0'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <path d='M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z' />
                    </svg>
                  </span>
                </button>
                <div className='icon-title text-center w-100'>Whatsapp</div>
              </div>

              <div className='icon-container'>
                <button
                  onClick={openSMSModal}
                  type='button'
                  className='btn btn-sm btn-light py-3 px-3'
                  style={{borderRadius: '50%'}}
                >
                  <span className='svg-icon svg-icon-primary svg-icon-2x m-0'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24px'
                      height='24px'
                      viewBox='0 0 24 24'
                      version='1.1'
                    >
                      <g stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                        <rect x='0' y='0' width='24' height='24' />
                        <polygon fill='#000000' opacity='0.3' points='5 15 3 21.5 9.5 19.5' />
                        <path
                          d='M13.5,21 C8.25329488,21 4,16.7467051 4,11.5 C4,6.25329488 8.25329488,2 13.5,2 C18.7467051,2 23,6.25329488 23,11.5 C23,16.7467051 18.7467051,21 13.5,21 Z M8.5,13 C9.32842712,13 10,12.3284271 10,11.5 C10,10.6715729 9.32842712,10 8.5,10 C7.67157288,10 7,10.6715729 7,11.5 C7,12.3284271 7.67157288,13 8.5,13 Z M13.5,13 C14.3284271,13 15,12.3284271 15,11.5 C15,10.6715729 14.3284271,10 13.5,10 C12.6715729,10 12,10.6715729 12,11.5 C12,12.3284271 12.6715729,13 13.5,13 Z M18.5,13 C19.3284271,13 20,12.3284271 20,11.5 C20,10.6715729 19.3284271,10 18.5,10 C17.6715729,10 17,10.6715729 17,11.5 C17,12.3284271 17.6715729,13 18.5,13 Z'
                          fill='#000000'
                        />
                      </g>
                    </svg>
                  </span>
                </button>
                <div className='text-center icon-title'>Sms</div>
              </div>
            </div>

            <hr className='my-3' />

            <div className='d-block text-left px-5 py-3'>
              <div className='form-group'>
                <label className='fw-bold'>Name</label>
                <p className='text-dark fw-medium  fs-4'>
                  {leadDetails?.lead_type === 1
                    ? leadDetails?.name
                    : leadDetails?.company_name || 'Name missing'}
                </p>
              </div>
              <div className='form-group'>
                <label className='fw-bold'>Email</label>
                <p className='text-dark fw-medium  fs-4'>
                  {leadDetails?.email ? leadDetails?.email : 'Email missing'}
                </p>
              </div>
              <div className='form-group'>
                <label className='fw-bold'>Phone Number</label>
                <p className='text-dark fw-medium  fs-4'>
                  {leadDetails?.phone ? leadDetails?.phone : 'Number missing'}
                </p>
              </div>
              <div className='form-group'>
                <label className='fw-bold'>Lead Status</label>
                <p className='text-dark fw-medium  fs-4'>
                  {leadDetails?.leadStatusDetails?.title
                    ? leadDetails?.leadStatusDetails?.title
                    : 'Status missing'}
                </p>
              </div>
              <div className='form-group'>
                <label className='fw-bold'>Lead Owner</label>
                <p className='text-dark fw-medium  fs-4'>
                  {leadDetails?.leadOwnerDetails?.name
                    ? leadDetails?.leadOwnerDetails?.name
                    : 'Details missing'}
                </p>
              </div>
              <div className='form-group'>
                <label className='fw-bold'>Company Name</label>
                <p className='text-dark fw-medium  fs-4 text-capitalize'>
                  {leadDetails?.company_name ? leadDetails?.company_name : 'Not available'}
                </p>
              </div>
            </div>

            <hr className='mb-3' />
            <div className='d-block text-left px-5 py-3'>
              <div className='form-group'>
                <label className='fw-bold' style={{color: '#095157'}}>
                  Ticket
                </label>
                <p className='text-dark fw-medium  fs-4'>Create a ticket from this conversation.</p>
              </div>
              <div className='form-group'>
                <button
                  className='btn btn-light w-100'
                  type='button'
                  style={{borderRadius: '50px'}}
                >
                  Create a Ticket
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className='col-lg-8'>
          <div className='w-100 d-flex justify-content-around'>
            <button
              type='button'
              className={`btn px-1 ${activeState === 1 ? '' : 'btn-light'}`}
              style={{
                borderRadius: 0,
                background: 'transparent',
                color: '#095157',
                borderBottom: activeState === 1 ? '2px solid #095157' : '',
                fontWeight: activeState === 1 ? '600' : '500',
              }}
              onClick={() => {
                handleChangeState(1)
                getActivityList()
              }}
            >
              Activity
            </button>
            <button
              type='button'
              className={`btn px-1 ${activeState === 2 ? '' : 'btn-light'}`}
              style={{
                borderRadius: 0,
                background: 'transparent',
                color: '#095157',
                borderBottom: activeState === 2 ? '2px solid #095157' : '',
                fontWeight: activeState === 2 ? '600' : '500',
              }}
              onClick={() => handleChangeState(2)}
            >
              Notes
            </button>
            <button
              type='button'
              className={`btn px-1 ${activeState === 3 ? '' : 'btn-light'}`}
              style={{
                borderRadius: 0,
                background: 'transparent',
                color: '#095157',
                borderBottom: activeState === 3 ? '2px solid #095157' : '',
                fontWeight: activeState === 3 ? '600' : '500',
              }}
              onClick={() => handleChangeState(3)}
            >
              Emails
            </button>
            <button
              type='button'
              className={`btn px-1 ${activeState === 4 ? '' : 'btn-light'}`}
              style={{
                borderRadius: 0,
                background: 'transparent',
                color: '#095157',
                borderBottom: activeState === 4 ? '2px solid #095157' : '',
                fontWeight: activeState === 4 ? '600' : '500',
              }}
              onClick={() => handleChangeState(4)}
            >
              Sms
            </button>
            <button
              type='button'
              className={`btn px-1 ${activeState === 5 ? '' : 'btn-light'}`}
              style={{
                borderRadius: 0,
                background: 'transparent',
                color: '#095157',
                borderBottom: activeState === 5 ? '2px solid #095157' : '',
                fontWeight: activeState === 5 ? '600' : '500',
              }}
              onClick={() => handleChangeState(5)}
            >
              Tickets
            </button>
          </div>

          <div className='mt-5' />
          {/* Activity */}
          <div style={{paddingTop: 1}}>
            {activeState === 1 &&
              activityList.map((activity: any, index: number) =>
                activity.type === 2 ? (
                  <div key={activity} className='card my-2 p-5'>
                    <EMAILCARD
                      title={activity.subject}
                      message={activity.details.replace(/<[^>]*>/g, '')}
                      date={moment(activity?.created_at).format('MMM D, YYYY')}
                    />
                  </div>
                ) : activity.type === 3 ? (
                  <div key={activity} className='card my-2 p-5'>
                    <SMSCARD
                      title={activity.subject}
                      message={activity.details}
                      date={moment(activity?.created_at).format('MMM D, YYYY')}
                    />
                  </div>
                ) : activity.type === 1 ? (
                  <div key={activity} className='card my-2 p-5'>
                    <NOTECARD
                      title={activity.subject}
                      message={activity?.details?.replace(/<[^>]*>/g, '')}
                      date={moment(activity?.created_at).format('MMM D, YYYY')}
                    />
                  </div>
                ) : (
                  <div key={activity} className='card my-2 p-5'>
                    <OTHERCARD
                      title={activity.subject}
                      message={activity?.details?.replace(/<[^>]*>/g, '')}
                      date={moment(activity?.created_at).format('MMM D, YYYY')}
                    />
                  </div>
                )
              )}
          </div>
          {/* Notes */}
          <div className='row'>
            {activeState === 2 && (role === 2 || leadDetails?.leadOwnerDetails?.id === userId) && (
              <div className='col-lg-12 text-end'>
                <button type='button' className='btn btn-sm btn-primary' onClick={openModal}>
                  + New Note
                </button>
              </div>
            )}
            {activeState === 2 &&
              notesList.map((e: any, index: number) => (
                <div key={index} className='col-lg-4 my-2'>
                  <div className='card p-5' style={{height: 230}}>
                    {(role === 2 || leadDetails?.leadOwnerDetails?.id === userId) && (
                      <div className='text-end'>
                        <button
                          style={{
                            position: 'absolute',
                            marginLeft: '-25px',
                            marginTop: '-10px',
                          }}
                          type='button'
                          className='btn btn-sm'
                          onClick={() => handleEditNote(e)}
                        >
                          <i className='fa fa-edit'></i>
                        </button>
                      </div>
                    )}
                    <GridCard
                      title={e?.subject ? e?.subject : 'Subject Missing ...'}
                      message={e?.details ? e?.details : 'No Message Here ...'}
                      date={
                        e?.created_at ? moment(e?.created_at).format('MMM D, YYYY') : 'Date missing'
                      }
                      authorName={
                        e?.activityCreatedBy?.name
                          ? e?.activityCreatedBy?.name
                          : 'Note Creator Name is Missing'
                      }
                    />
                  </div>
                </div>
              ))}
          </div>

          {/* Email */}
          <div className='row'>
            {activeState === 3 &&
              emailList.map((email: any) => (
                <div key={email.id} className='card my-2 p-5'>
                  <EMAILCARD
                    title={email?.subject}
                    message={email?.details.replace(/<[^>]*>/g, '')}
                    date={moment(email?.created_at).format('MMM D, YYYY')}
                  />
                </div>
              ))}
          </div>

          {/* SMS */}
          {activeState === 4 &&
            smsList.map((sms: any) => (
              <div key={sms} className='card my-2 p-5'>
                <SMSCARD
                  title={sms?.subject}
                  message={sms?.details}
                  date={moment(sms?.created_at).format('MMM D, YYYY')}
                />
              </div>
            ))}
        </div>

        {/* MODAL => Note */}
        {noteModalOpen && (
          <div className='modal' tabIndex={-1} role='dialog' style={{display: 'block'}}>
            <div className='modal-dialog modal-dialog-centered' role='document'>
              <div className='modal-content'>
                <form onSubmit={handleSubmit}>
                  <div className='modal-header'>
                    <h5 className='modal-title'>
                      {selectedEdit > 0 ? 'Edit Note' : 'Add New Note'}
                    </h5>
                    <button type='button' className='btn-close' onClick={closeModal}>
                      {/* <span>&times;</span> */}
                    </button>
                  </div>

                  <div className='modal-body'>
                    <div className='form-group d-flex'>
                      <label
                        htmlFor='title'
                        className='fw-bold align-self-center w-20'
                        style={{width: '20%'}}
                      >
                        Note Title:
                      </label>
                      <input
                        type='text'
                        className='form-control'
                        style={{width: '80%'}}
                        id='title'
                        value={title}
                        onChange={handleTitleChange}
                        placeholder='Enter Title'
                      />
                    </div>

                    <div className='form-group mt-4'>
                      {/* <label htmlFor='content'>Note Message:</label> */}
                      <CKEditor
                        editor={ClassicEditor}
                        data={editorData}
                        config={editorConfig}
                        onChange={handleEditorDataChange}
                      />
                    </div>

                    <div className='form-group text-end mt-3'>
                      <button type='submit' className='btn btn-primary' style={{borderRadius: 80}}>
                        {selectedEdit > 0 ? 'Edit Note' : 'Create Note'}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {noteModalOpen && <div className='modal-backdrop fade show'></div>}

        {emailModalOpen && (
          <div
            style={{
              height: 450,
              width: 560,
              display: 'block',
              position: 'fixed',
              bottom: 10,
              borderRadius: 10,
              right: 60,
              padding: 0,
              borderColor: '#949494',
              borderWidth: 1,
              backgroundColor: 'white',
              boxShadow: ' rgba(149, 157, 165, 0.2) 0px 8px 24px',
            }}
          >
            <div
              style={{
                borderTopRightRadius: 10,
                borderTopLeftRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#B3B3B3',
                paddingTop: 10,
                paddingBottom: 5,
                paddingLeft: 20,
                paddingRight: 10,
              }}
            >
              <h5 style={{color: 'white'}}>New Email</h5>
              <div style={{justifyContent: 'end', display: 'flex'}}>
                <button
                  type='button'
                  style={{border: 0, backgroundColor: 'transparent', color: 'white'}}
                  onClick={minimizeEmailModal}
                >
                  --
                </button>
                <button
                  type='button'
                  className='btn-close btn-close-white'
                  style={{marginLeft: 10, fontSize: 20}}
                  onClick={closeEmailModal}
                ></button>
              </div>
            </div>

            <div style={{padding: 15}}>
              <div>
                <form onSubmit={handleEmailSubmit}>
                  <div>
                    <div className='form-group d-flex mb-4'>
                      <input
                        disabled
                        type='text'
                        className='form-control'
                        style={{
                          borderBottomWidth: 1,
                          borderBottomColor: '#757575',
                          backgroundColor: 'white',
                          borderTop: 0,
                          borderLeft: 0,
                          borderRight: 0,
                        }}
                        id='title'
                        value={leadDetails?.email}
                        placeholder={leadDetails?.email ?? 'No User Email Found'}
                      />
                    </div>

                    <div className='form-group d-flex'>
                      <input
                        type='text'
                        className='form-control'
                        style={{
                          borderBottomWidth: 1,
                          borderBottomColor: '#757575',
                          backgroundColor: 'white',
                          borderTop: 0,
                          borderLeft: 0,
                          borderRight: 0,
                        }}
                        id='subject'
                        value={subject}
                        onChange={handleSubjectChange}
                        placeholder='Enter Subject'
                      />
                    </div>

                    <div className='form-group mt-4'>
                      <div
                        style={{
                          maxHeight: 200, // Adjust this value as needed
                          overflowY: 'auto',
                        }}
                      >
                        <CKEditor
                          editor={ClassicEditor}
                          data={emailEditorData}
                          config={editorEmailConfig}
                          onChange={handleEmailEditorDataChange}
                        />
                      </div>
                    </div>

                    <div className='form-group text-start mt-3'>
                      <button
                        type='submit'
                        style={{
                          width: 114,
                          borderRadius: 10,
                          backgroundColor: '#4F504D',
                          fontSize: 15,
                          color: 'white',
                          border: 0,
                        }}
                      >
                        Send
                      </button>
                      <button
                        onClick={closeEmailModal}
                        style={{
                          width: 114,
                          borderRadius: 10,
                          backgroundColor: '#F2F5F6',
                          fontSize: 15,
                          color: '#464040',
                          marginLeft: 20,
                          borderColor: '#A6A6A6',
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {emailModalMinimize && (
          <div>
            <button
              onClick={() => {
                setEmailModalOpen(true)
                setEmailModalMinimize(false)
              }}
              style={{
                textAlign: 'center',
                fontSize: 16,
                height: 50,
                width: 400,
                position: 'fixed',
                bottom: 10,
                borderColor: '#949494',
                right: 60,
                backgroundColor: 'white',
                boxShadow: ' rgba(149, 157, 165, 0.2) 0px 8px 24px',
              }}
            >
              New Email
            </button>
          </div>
        )}

        {smsModalOpen && (
          <div
            style={{
              height: 450,
              width: 560,
              display: 'block',
              position: 'fixed',
              bottom: 10,
              borderRadius: 10,
              right: 60,
              padding: 0,
              borderColor: '#949494',
              borderWidth: 1,
              backgroundColor: 'white',
              boxShadow: ' rgba(149, 157, 165, 0.2) 0px 8px 24px',
            }}
          >
            <div
              style={{
                borderTopRightRadius: 10,
                borderTopLeftRadius: 10,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: '#B3B3B3',
                paddingTop: 10,
                paddingBottom: 5,
                paddingLeft: 20,
                paddingRight: 10,
              }}
            >
              <h5 style={{color: 'white'}}>New Message</h5>
              <div style={{justifyContent: 'end', display: 'flex'}}>
                <button
                  type='button'
                  style={{border: 0, backgroundColor: 'transparent', color: 'white'}}
                  onClick={minimizeSmsModal}
                >
                  --
                </button>
                <button
                  type='button'
                  className='btn-close btn-close-white'
                  style={{marginLeft: 10, fontSize: 20}}
                  onClick={closeSmsModal}
                ></button>
              </div>
            </div>

            <div style={{padding: 15}}>
              <div>
                <form onSubmit={handleSmsSubmit}>
                  <div>
                    <div className='form-group d-flex mb-4'>
                      <input
                        disabled
                        type='text'
                        className='form-control'
                        style={{
                          borderBottomWidth: 1,
                          borderBottomColor: '#757575',
                          backgroundColor: 'white',
                          borderTop: 0,
                          borderLeft: 0,
                          borderRight: 0,
                        }}
                        id='title'
                        value={leadDetails?.phone}
                        placeholder={leadDetails?.phone ?? 'No User Phone Number Found'}
                      />
                    </div>
                    <div className='form-group mt-4'>
                      <p style={{fontSize: 15, fontWeight:'bold', marginLeft:5}}>Message<span style={{color:'red'}}>*</span></p>
                    </div>

                    <div className='form-group mt-4'>
                      <textarea
                        id='sms'
                         className='form-control'
                        // placeholder='Enter Template Message'
                        value={smsDescription}
                        onChange={(e) => setSmsDescription(e.target.value)}
                        style={{height: 250, borderRadius: 15, width: '100%'}}
                      />
                    </div>

                    <div className='form-group text-start mt-3'>
                      <button
                        type='submit'
                        style={{
                          width: 114,
                          borderRadius: 10,
                          backgroundColor: '#4F504D',
                          fontSize: 15,
                          color: 'white',
                          border: 0,
                        }}
                      >
                        Send
                      </button>
                      <button
                        onClick={closeSmsModal}
                        style={{
                          width: 114,
                          borderRadius: 10,
                          backgroundColor: '#F2F5F6',
                          fontSize: 15,
                          color: '#464040',
                          marginLeft: 20,
                          borderColor: '#A6A6A6',
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        {smsModalMinimize && (
          <div>
            <button
              onClick={() => {
                setSmsModalOpen(true)
                setSmsModalMinimize(false)
              }}
              style={{
                textAlign: 'center',
                fontSize: 16,
                height: 50,
                width: 400,
                position: 'fixed',
                bottom: 10,
                borderColor: '#949494',
                right: 60,
                backgroundColor: 'white',
                boxShadow: ' rgba(149, 157, 165, 0.2) 0px 8px 24px',
              }}
            >
              New SMS
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ContactUserDetails
